"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieLoader = exports.getCrossDomainCookieOptions = void 0;
var Cookies = require("js-cookie");
var StorageLoaderBase_1 = require("./StorageLoaderBase");
var StorageUtils_1 = require("./utils/StorageUtils");
/**
 * Default cross domain cookie options.
 */
var getCrossDomainCookieOptions = function () {
    var cookieOptions = {};
    if ((0, StorageUtils_1.isInIframe)()) {
        cookieOptions = __assign(__assign({}, cookieOptions), { sameSite: 'none' });
    }
    if ((0, StorageUtils_1.isSecureDomain)()) {
        cookieOptions = __assign(__assign({}, cookieOptions), { secure: true });
    }
    return cookieOptions;
};
exports.getCrossDomainCookieOptions = getCrossDomainCookieOptions;
function isEmpty(value) {
    return (value == null || value === '');
}
var CookieLoader = /** @class */ (function (_super) {
    __extends(CookieLoader, _super);
    function CookieLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Clears data stored in the cookie.
     */
    CookieLoader.prototype.ClearStorage = function (domainName) {
        try {
            if (isEmpty(domainName)) {
                Cookies.remove(this.storageKey);
            }
            else
                Cookies.remove(this.storageKey, { domain: domainName });
        }
        catch (ex) {
            this.logger.error(ex);
        }
    };
    /**
     * Loads data stored in the cookie.
     *
     * @throws SecurityError if cookies are disabled
     */
    CookieLoader.prototype.LoadStorage = function () {
        var storedAlmeSession = Cookies.get(this.storageKey);
        if (storedAlmeSession) {
            return JSON.parse(atob(storedAlmeSession));
        }
        else {
            return null;
        }
    };
    /**
     * Returns data stored in the cookie.
     *
     * @throws SecurityError if cookies are disabled
     */
    CookieLoader.prototype.GetStorage = function () {
        return this.LoadStorage();
    };
    /**
     * Updates Alme session data stored in the cookie.
     *
     * @throws cookie exceptions
     */
    CookieLoader.prototype.UpdateStorage = function (data) {
        Cookies.set(this.storageKey, btoa(JSON.stringify(data)), this.cookieOptions);
        return this.GetStorage();
    };
    return CookieLoader;
}(StorageLoaderBase_1.StorageLoaderBase));
exports.CookieLoader = CookieLoader;
//# sourceMappingURL=CookieLoader.js.map